import { useStores } from 'Hooks/useStore';
import { useIsLMSModulesHidden } from 'Hooks';
import { useCallback, useMemo, useEffect, useState } from 'react';
import { NavItemConfig, mainNavItems, accountItems, PEAKPORTAL_KEY } from '../Siderbar.constant';
import { PermissionCode } from 'Services/Api/Users/Types';
import Icon from 'Components/Icon/Icon';

export const useMenuItems = () => {
    const [menuItems, setMenuItems] = useState<NavItemConfig[]>(mainNavItems);
    const { systemsStore, authStore : { currentUserPermissionCodes} } = useStores();
    const isModulesNavHidden = useIsLMSModulesHidden();

    useEffect(() => {
        async function getSystems() {
            if(!systemsStore.systems.length) await systemsStore.loadSystems();
            if (systemsStore.systems.length && !isModulesNavHidden && menuItems[menuItems.length - 1].key != "modules") {
                setMenuItems((menuItems) => {
                    return menuItems.concat({
                        key: 'modules',
                        label: 'Modules',
                        icon: <Icon type="modulesIcon" />,
						children: systemsStore.systems.map((system) => ({
                            key: PEAKPORTAL_KEY,
                            label: system.systemName
                        }))
                    });
                });
            }
        }
        getSystems();
    }, []);

    const getIsMenuItemVisible = useCallback((menuItem: NavItemConfig) => (!menuItem.key || ["PeakPortal", "whitelisting", "policies", "my-courses", "assignments"].includes(menuItem.key) || currentUserPermissionCodes.includes((menuItem.key as PermissionCode) || '')), [currentUserPermissionCodes]);

    const calculatedMenuItems = useMemo(() => {
        return menuItems.reduce<NavItemConfig[]>((acc, value) => {
            if (value.children) {
                const children = value.children.filter(getIsMenuItemVisible);
                if (children.length) acc.push({ ...value, children });
            } else {
                if (getIsMenuItemVisible(value)) acc.push(value);
            }
            return acc;
        }, []);
    }, [getIsMenuItemVisible, menuItems]);

    return { menuItems: calculatedMenuItems };
};
